// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduleBookingForm-scheduleClockBtn-Bxpql {
    -ms-flex-negative: 0;
        flex-shrink: 0;
    height: 44px;
    border: 1px solid var(--primary-bg) !important;
    background: var(--primary-bg) !important;
    border-radius: 0 var(--radius-1) var(--radius-1) 0;
    padding: 11px 12px !important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.ScheduleBookingForm-scheduleClockBtn-Bxpql img {
    width: 22px;
    height: 22px;
}`, "",{"version":3,"sources":["webpack://./src/components/ScheduleBookingForm/ScheduleBookingForm.css"],"names":[],"mappings":"AAAA;IACI,oBAAc;QAAd,cAAc;IACd,YAAY;IACZ,8CAA8C;IAC9C,wCAAwC;IACxC,kDAAkD;IAClD,6BAA6B;IAC7B,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".scheduleClockBtn {\n    flex-shrink: 0;\n    height: 44px;\n    border: 1px solid var(--primary-bg) !important;\n    background: var(--primary-bg) !important;\n    border-radius: 0 var(--radius-1) var(--radius-1) 0;\n    padding: 11px 12px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.scheduleClockBtn img {\n    width: 22px;\n    height: 22px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scheduleClockBtn": `ScheduleBookingForm-scheduleClockBtn-Bxpql`
};
module.exports = ___CSS_LOADER_EXPORT___;
